import { createSlice } from "@reduxjs/toolkit";
import { SweetAlertOptionalProps } from "../../../reusable/SweetAlert/SweetAlert";

const initialiState = {
  show: false,
  message: "",
  title: "",
  onCancel: {},
  onConfirm: {},
  customButtons: {},
} as SweetAlertOptionalProps;

const sweetAlertSlice = createSlice({
  name: "SweetAlertSlice",
  initialState: initialiState,
  reducers: {
    activateSweetAlert(state, action) {
      const { message, title = "", onConfirm, confirmBtnText, type, cancelBtnText, onCancel, focusCancelBtn, showCancel, customClass, confirmBtnBsStyle, customButtons } = action.payload;
      state.show = true;
      state.type = type;
      state.message = message;
      state.title = title;
      state.onConfirm = onConfirm;
      state.confirmBtnText = confirmBtnText;
      state.closeOnClickOutside = false;
      state.cancelBtnText = cancelBtnText;
      state.onCancel = onCancel;
      state.focusCancelBtn = focusCancelBtn;
      state.showCancel = showCancel;
      state.cancelBtnBsStyle = "light";
      state.customClass = customClass;
      state.confirmBtnBsStyle = confirmBtnBsStyle;
      state.customButtons = customButtons;
    },
    deActivateSweetAlert(state) {
      state.show = false;
    },
  },
});

export const { activateSweetAlert, deActivateSweetAlert } =
  sweetAlertSlice.actions;
export default sweetAlertSlice.reducer;
